export const MANGOPAY_KYC_DOCUMENT_IDENTITY_PROOF_MIN_BYTES = 32000;
export const MANGOPAY_KYC_DOCUMENT_DEFAULT_MIN_BYTES = 1000;
export const MANGOPAY_KYC_DOCUMENT_DEFAULT_MAX_BYTES = 10000000;

export const MILLIS_PER_HOUR = 3600000;
export const MILLIS_PER_DAY = 86400000;
